import React, { useState } from "react";
import PageWrapper from "../components/PageWrapper";
import Colors from '../styles/Colors.json';
import { useSiteContext } from "../SiteContext";
import { generateDailyPayrollReport } from "../api/reports";
import './ReportsPage.css';

interface Report {
    id: string;
    name: string;
}

const ReportsPage: React.FC = () => {
    const { translator, payPeriodID, setLoading, createPopup } = useSiteContext();
    const [generating, setGenerating] = useState<string | null>(null);

    // List of available reports
    const reports: Report[] = [
        { id: 'daily-payroll-v2', name: 'Daily Payroll Report v2' }
    ];

    const handleGenerateReport = async (reportId: string) => {
        if (!payPeriodID || payPeriodID === 0) {
            createPopup("Error", "Please select a pay period to generate the report.");
            return;
        }

        setGenerating(reportId);
        setLoading(true);

        try {
            let result;
            
            if (reportId === 'daily-payroll-v2') {
                const emailTo: string[] = [];
                result = await generateDailyPayrollReport(payPeriodID, emailTo);
            } else {
                createPopup("Error", "Unknown report type.");
                return;
            }

            if (result.success) {
                createPopup("Success", "Report generated. You will receive an email shortly.");
            } else {
                createPopup("Error", result.message || "Failed to generate report. Please try again.");
            }
        } catch (error) {
            console.error("Error generating report:", error);
            createPopup("Error", "An error occurred while generating the report. Please try again.");
        } finally {
            setGenerating(null);
            setLoading(false);
        }
    };

    return (
        <PageWrapper title={translator.translate("Reports")} backgroundColor={Colors.White} weekSelector={true}>
            <div className="reports-container">
                <div className="reports-list">
                    {reports.map((report) => (
                        <div key={report.id} className="report-item">
                            <div className="report-name">{report.name}</div>
                            <button
                                className="report-generate-button"
                                onClick={() => handleGenerateReport(report.id)}
                                disabled={generating === report.id || !payPeriodID || payPeriodID === 0}
                            >
                                {generating === report.id ? "Generating..." : "Generate Report"}
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </PageWrapper>
    );
};

export default ReportsPage;

